import { Component, OnInit, Input, Inject, Optional, ViewChild, ViewEncapsulation, OnChanges } from '@angular/core';
import { PedidoCliente } from '../../domain/pedido-cliente';
import { MAT_DIALOG_DATA, MatTableDataSource, MatPaginator } from '@angular/material';
import { Imagen } from '../../domain/imagen';
import { GLOBAL } from '../../global';
import { DetallePedidoCliente } from '../../domain/detalle-pedido-cliente';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderComponent implements OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() pedido : PedidoCliente;

  public urlBucket: string = GLOBAL.URL_BUCKET;
  public imagenDefecto: Imagen = GLOBAL.IMAGEN_DEFECTO;

  public list = new MatTableDataSource<DetallePedidoCliente>();

  displayedColumns: string[] = ['imagen', 'codigo', 'nombre', 'cantidad', 'precio', 'iva'];

  constructor( @Optional() @Inject(MAT_DIALOG_DATA) public data:any) {
    if(data != null){
      this.pedido = data.pedido;
      this.list = new MatTableDataSource<DetallePedidoCliente>(this.pedido.detallesPedido);
      this.list.paginator = this.paginator;
    }
  }

  ngOnChanges(){
    if(this.pedido !== null && this.pedido !== undefined &&
        (this.list.data.length === 0)){
          this.list = new MatTableDataSource<DetallePedidoCliente>(this.pedido.detallesPedido);
          this.list.paginator = this.paginator;  
    }
  }

  public close(): void {
    //this.dialogRef.close(false);
  }
}
